import { Directive, HostListener, Input } from '@angular/core';
import { AnalyticsEventsEnum } from '@core/models/analytics.model';
import { AnalystService } from '@app/services/analyst/analyst.service';


@Directive({
  // eslint-disable-next-line @angular-eslint/directive-selector
  selector: '[analytics]',
  standalone: true,
})
export class AnalyticsDirective {

  @Input('analytics') target!: AnalyticsEventsEnum; // Название цели в Метрике

  @Input() params: any = {}; // Дополнительные параметры для Метрики

  constructor(
    private analyticsService: AnalystService,
  ) {}

  @HostListener('click', ['$event'])
  handleClick(): void {
    this.analyticsService.logEvent(this.target, this.params).then();
  }

}
